import React from "react";
import { Link } from "react-router-dom";
import { Radio, Mail, ExternalLink } from "lucide-react";

export const Footer = () => {
  return (
    <footer className="border-t border-[#272E3A] bg-[#0A0C10] mt-24" data-testid="site-footer">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 lg:py-24">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-10">
          <div className="md:col-span-2">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 bg-[#FF5500] flex items-center justify-center">
                <Radio className="w-5 h-5 text-black" strokeWidth={2.5} />
              </div>
              <div>
                <div className="font-display font-black text-white text-xl">Eastern US Meshcore</div>
                <div className="font-mono text-[10px] uppercase tracking-[0.25em] text-[#FF5500]">
                  Off-grid // Resilient // Community-owned // Fun
                </div>
              </div>
            </div>
            <p className="text-slate-400 max-w-md leading-relaxed">
              A community-built mesh communication network across the East Coast, powered by license-free LoRa radios and
              the open-source MeshCore firmware. No grid, no internet, no problem.
            </p>
          </div>

          <div>
            <div className="overline mb-4">Network</div>
            <ul className="space-y-2.5">
              <li><Link to="/meshcore" className="text-slate-300 hover:text-[#FF5500] text-sm">What is MeshCore</Link></li>
              <li><Link to="/devices" className="text-slate-300 hover:text-[#FF5500] text-sm">Supported Devices</Link></li>
              <li><Link to="/settings" className="text-slate-300 hover:text-[#FF5500] text-sm">Radio Settings</Link></li>
              <li><Link to="/mqtt" className="text-slate-300 hover:text-[#FF5500] text-sm">Observer / MQTT</Link></li>
              <li><Link to="/blog" className="text-slate-300 hover:text-[#FF5500] text-sm">Blog</Link></li>
            </ul>
          </div>

          <div>
            <div className="overline mb-4">Community</div>
            <ul className="space-y-2.5">
              <li>
                <a
                  href="https://discord.gg/3TPXsHBv6t"
                  target="_blank"
                  rel="noopener noreferrer"
                  data-testid="footer-discord"
                  className="flex items-center gap-2 text-slate-300 hover:text-[#FF5500] text-sm"
                >
                  Discord <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a
                  href="https://meshcore.io"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-slate-300 hover:text-[#FF5500] text-sm"
                >
                  MeshCore.io <ExternalLink className="w-3 h-3" />
                </a>
              </li>
              <li>
                <a
                  href="http://flasher.meshcore.io/"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="flex items-center gap-2 text-slate-300 hover:text-[#FF5500] text-sm"
                >
                  Web Flasher <ExternalLink className="w-3 h-3" />
                </a>
              </li>
            </ul>
          </div>
        </div>

        <div className="mt-16 pt-8 border-t border-[#272E3A] flex flex-col sm:flex-row justify-between gap-4">
          <div className="font-mono text-xs text-[#94A3B8]">
            © {new Date().getFullYear()} Eastern US Meshcore
          </div>
          <div className="font-mono text-xs text-[#94A3B8]">
            <span className="inline-block w-2 h-2 bg-[#10B981] rounded-full animate-pulse-dot mr-2 align-middle" />
            NETWORK STATUS: OPERATIONAL
          </div>
        </div>
      </div>
    </footer>
  );
};
